/* eslint-disable no-unused-vars */
import React from 'react';
import './home.css'
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";

import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import {withRouter,NavLink} from 'react-router-dom'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import {setUser} from '../../redux/actions/AuthActions'
import Skeleton from 'react-loading-skeleton';
import { Line } from "react-chartjs-2";
import moment from 'moment'
import { Spin ,TreeSelect,DatePicker,ConfigProvider,Image} from 'antd';
import 'moment/locale/ar';
import locale_ar from 'antd/lib/locale/ar_EG';
import locale_en from 'antd/lib/locale/en_GB';
const { RangePicker } = DatePicker;
const { TreeNode } = TreeSelect;
let startDate,endDate;
class Home extends React.Component {
  
  state = {
    count:[],
    tops:[],
    lastUsers:[],
    user:[],
    gifts:[],
    loading:true,
    topActiveTeacher:null,
    topLecture:null,
    topStudent:null,
    clients:[],
    posts:[],
    days:[],
    daysEN:[],
    daysAR:[],
    maxValue:0,
    graphStep:0,
    filter:null,
    duration:null,
    startDate:null
  }
  
   
  constructor(props){
    super(props)
    this.onChange = this.onChange.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this)

    this.getCount()
    //this.getTop()
    this.getLastUsers()
    this.getGifts()
    this.getGraph(null)
    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
      moment.locale('ar');
    }else{
      allStrings.setLanguage('en')
      moment.locale('en');
    } 

  }
  getGraph = (duration,startDate,endDate) => {
    let url = `${BASE_END_POINT}admin/getGraph`
    if(duration ==="TODAY"){
      url = `${BASE_END_POINT}admin/getGraph?duration=DAY`
    }
    if(duration ==="DAY"){
      url = `${BASE_END_POINT}admin/getGraph?duration=${duration}&startDate=${startDate}`
    }
    if(duration ==="WEEK"){
      url = `${BASE_END_POINT}admin/getGraph?duration=${duration}`
    }
    if(duration ==="DURATION"){
      url = `${BASE_END_POINT}admin/getGraph?startDate=${startDate}&endDate=${endDate}`
    }
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log(response.data)
      let daysEN=[]
      let daysAR=[]
      response.data.theDays.forEach(day => {
        if(duration){
          if(duration ==="TODAY"){
            console.log("today")
            daysAR.push(moment(day).locale('ar').format("h a"))
            daysEN.push(moment(day).locale('en').format('LT'))
          }
          if(duration ==="DAY"){
            console.log("day")
            daysAR.push(moment(day).locale('ar').format("h a"))
            daysEN.push(moment(day).locale('en').format('LT'))
          }
          if(duration ==="WEEK"){
            console.log("week")
            daysAR.push(moment(day).locale('ar').format("ll"))
            daysEN.push(moment(day).locale('en').format('MMM Do YY'))
          }
          if(duration ==="DURATION"){
            console.log("duration")
            daysAR.push(moment(day).locale('ar').format("ll"))
            daysEN.push(moment(day).locale('en').format('MMM Do YY'))
          }
        }else{
            console.log("duration")
            daysAR.push(moment(day).locale('ar').format("ll"))
            daysEN.push(moment(day).locale('en').format('MMM Do YY'))
        }
        
        
        //dayA.push(dayNameA(day))
      });
      let arr = response.data.theClients
      let maxValue1 = Math.max( ...arr );

      let max = maxValue1;

      let arr2 = response.data.thePosts
      let maxValue2 = Math.max( ...arr2 );
      if(maxValue2 > maxValue1)
        max = maxValue2

       
      this.setState({
        loading: false,
        clients:response.data.theClients,
        posts:response.data.thePosts,
        daysEN:daysEN,
        daysAR:daysAR,
        maxValue:max,
        graphStep:Math.floor(max / 10)
      })
    })
    .catch(error=>{
      console.log("ALL graph ERROR")
      console.log(error)
    })
  }
  getLastUsers = () => {
    axios.get(`${BASE_END_POINT}admin/lastUsers`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log(response.data)
      this.setState({lastUsers:response.data.users})
    })
    .catch(error=>{
      console.log("ALL lastUsers ERROR")
      console.log(error.response)
    })
  }
  getCount = () => {
    axios.get(`${BASE_END_POINT}admin/count`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
    })
    .then(response=>{
      console.log(response.data)
      this.setState({count:response.data,loading:false})
    })
    .catch(error=>{
      console.log("ALL count ERROR")
      console.log(error.response)
    })
  }
  getTop = () => {
    console.log(this.state.fromDate)
    axios.get(`${BASE_END_POINT}admin/top`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
    })
    .then(response=>{
      console.log(response.data)
      this.setState({top:response.data,loading:false,topStudent:response.data.topStudent,
      topActiveTeacher:response.data.topActiveTeacher,topLecture:response.data.topLecture})
    })
    .catch(error=>{
      console.log("ALL top ERROR")
      console.log(error.response)
    })
  }
  getGifts = () => {
    axios.get(`${BASE_END_POINT}gifts?page=1&limit=8&end=false`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log(response.data.data)
      this.setState({gifts:response.data.data})
    })
    .catch(error=>{
      console.log("ALL gifts ERROR")
      console.log(error.response)
    })
  }

  componentDidMount(){
    //this.props.ChangeLanguage(false)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
      moment.locale('ar');
    }else{
      allStrings.setLanguage('en')
      moment.locale('en');
    } 
  
  }
  onChange(dates, dateStrings) {
    console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    if(this.props.isRTL){
      this.setState({
        startDate:moment(dateStrings[0]).format("YYYY-MM-DD"),
        endDate:moment(dateStrings[1]).format("YYYY-MM-DD"),
      })
    }else{
      this.setState({
        startDate:moment(dateStrings[0]).locale('en').format("YYYY-MM-DD"), 
        endDate:moment(dateStrings[1]).locale('en').format("YYYY-MM-DD"),
      })
    }
    startDate = moment(dateStrings[0]).locale('en').format("YYYY-MM-DD")
    endDate = moment(dateStrings[1]).locale('en').format("YYYY-MM-DD")
    this.getGraph("DURATION",startDate,endDate)
  }
  onChangeDate(dates, dateString) {
    console.log('date: ', dateString);
    if(this.props.isRTL){
      this.setState({startDate:moment(dateString).format("YYYY-MM-DD"), duration:'DAY'})
    }else{
      this.setState({startDate:moment(dateString).locale('en').format("YYYY-MM-DD"), duration:'DAY' })
    }
    startDate = moment(dateString).locale('en').format("YYYY-MM-DD")
    this.getGraph("DAY",startDate)
  }
  render(){
    const data = {
      labels:this.props.isRTL?this.state.daysAR:this.state.daysEN,
      datasets: [
        {
          label: allStrings.clients,
          data: this.state.clients,
          fill: true,
          backgroundColor: 'rgba(157, 248, 255, 0.411)',
          borderColor: 'rgba(157, 248, 255, 0.411)',
          pointBorderColor:'rgba(157, 248, 255, 0.411)',
          pointBackgroundColor:'rgba(255, 255,255)',
          pointBorderWidth:5,
          yAxisID: 'y-axis-1',
          
        },
        {
          label: allStrings.posts,
          data:this.state.posts,
          fill: true,
          backgroundColor: 'rgba(195, 193, 252, 0.555)', 
          borderColor: 'rgba(54, 162, 235, 0.2)',
          pointBorderColor:'rgba(54, 162, 235, 0.2)',
          pointBackgroundColor:'rgba(255, 255, 255, 1)',
          pointBorderWidth:5,
          yAxisID: 'y-axis-2',
        },
      ],
    }
    
    const options = {
      maintainAspectRatio : false,
      responsive: true,
      legend: {
        display: true,
        position:'bottom',
        align:this.props.isRTL?'end':'start',

        labels: {
            // This more specific font property overrides the global property
            fontColor: '#000',
            borderRadius:'4px',
            boxWidth:20,
            padding:20,
            
        }
      },
      scales: {
        
        yAxes: [
          {
            type: 'linear',
            display: true,
            stacked: true,
            position: 'left',
            id: 'y-axis-1',
            ticks: {
              max: this.state.maxValue,
              min: 0,
              stepSize: this.state.graphStep
            },
            barPercentage: 1,
            offsetGridLines: false,
            gridLines: {
              offsetGridLines: false,
              display: true,
              color: "#F0F2F5",
              borderStyle:'dashed'
            },
          },
          {
            type: 'linear',
            display: false,
            position: 'right',
            id: 'y-axis-2',
            ticks: {
              max: this.state.maxValue,
              min: 0,
              stepSize: this.state.graphStep
            },
            barPercentage: 1,
            offsetGridLines: false,
            gridLines: {
              offsetGridLines: false,
              display: true,
              color: "#F0F2F5",
              borderStyle:'dashed'
            },
            
          },
        ],
      },
    }
    let {loading,lastUsers} = this.state;
  return (
    <div className="Home">
      <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{color:'#117183'}}>
      <MDBContainer> 
        <MDBRow>
          
         <div style={{textAlign:this.props.isRTL? 'right':'left',
         flexDirection:this.props.isRTL?'row':'row-reverse',
         display:this.props.isRTL?'': 'flex',
         width:this.props.isRTL?'100%': '',padding: '5px 20px 25px'}}>
          <span  style={{
            display: 'inline-block',
            color: '#43425D',
            fontSize:'22px'}}>{allStrings.statistic}</span>
          <span  style={{fontFamily:'system-ui',fontWeight:'bold',fontSize:'22px',display: 'inline-block',
            color: '#43425D',margin:'6px',lineHeight:this.props.isRTL?'auto':'15px'}}>|</span>
          <span style={{fontFamily:'system-ui',fontWeight:'bold',fontSize:'22px',display: 'inline-block',
            color: '#43425D'}}>{allStrings.overView}</span>
         </div>
         
        </MDBRow>
        <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>

          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.usersCount}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart1.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.users}</p>
                  
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.supervisors}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart2.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.subAdmins}</p>
                    
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.admins}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart3.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.adminsCount}</p>
                    
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.gifts}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart4.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.gifts}</p>
                   
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.productsCount}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart5.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.productsCount}</p>
                    
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.postsCount}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart6.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.postsCount}</p>
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
        </MDBRow>
       
      
        <br></br>
        <MDBRow>
          <MDBCol  md="12">
            <p style={{
                fontFamily: 'system-ui',
                background:' #fff',
                marginBottom: '0px',
                padding: '18px 22px',
                fontWeight: '600',
                color: '#43425D',
                fontSize: '17px',
                textAlign: this.props.isRTL?'right':'left'
            }}>{allStrings.statistic}</p>
            <MDBRow style={{marginLeft:0,marginRight:0,flexDirection:this.props.isRTL?'row':'row-reverse',padding:'10px',background:'#fff'}}>
              <MDBCol xl="3" lg="3" md="3" sm="12"></MDBCol>
              <MDBCol xl="3" lg="3" md="3" sm="12"></MDBCol>
              <MDBCol xl="3" lg="3" md="3" sm="12">
                {this.state.filter ==="DURATION"&&
                <span>
                  <label htmlFor="form605" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.duration}</label>
                  <ConfigProvider locale={this.props.isRTL?locale_ar:locale_en}>
                    <RangePicker format={"YYYY-MM-DD"} placeholder={[allStrings.startDate,allStrings.endDate]} onChange={this.onChange} style={{width:"100%"}}/>
                  </ConfigProvider>
                </span>
                }
                {this.state.filter ==="DAY"&&
                <span>
                  <label htmlFor="form605" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.date}</label>
                  <ConfigProvider locale={this.props.isRTL?locale_ar:locale_en} >
                    <DatePicker format={"YYYY-MM-DD"} placeholder={allStrings.date} onChange={this.onChangeDate} style={{width:"100%",direction:this.props.isRTL?'rtl':'ltr'}}/>
                  </ConfigProvider>
                </span>
                }
              </MDBCol>
              <MDBCol xl="3" lg="3" md="3" sm="12" style={{background:"#fff"}}>
                  <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.filter}</label>
                  <TreeSelect virtual={false}
                    showSearch={false}
                    value={this.state.filter}
                    style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px'}} 
                    treeCheckable = {false}         
                    treeNodeFilterProp="title"                      
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder={allStrings.filter}
                    onChange={(value) => {
                    console.log(value)
                    this.setState({filter:value});
                      if(value ==="WEEK"){
                        this.getGraph("WEEK")
                      }
                      if(value ==="TODAY"){
                        this.getGraph("TODAY")
                      }
                    }} 
                
                >
                    <TreeNode value="WEEK" title={allStrings.week} key="WEEK" />
                    <TreeNode value="TODAY" title={allStrings.today} key="TODAY" />
                    <TreeNode value="DAY" title={allStrings.determineDay} key="DAY" />
                    <TreeNode value="DURATION" title={allStrings.duration} key="DURATION" />
                </TreeSelect>
              </MDBCol>
            </MDBRow>
            <div className="homeChart">
            <Line height="400px" data={data} options={options} />
            </div>
          </MDBCol>
        </MDBRow>
        <br></br>
        {/*}
        <MDBRow>
          <MDBCol xl="4" lg="6" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard">{allStrings.topOfficecountry.isoCode}</p>
                <MDBRow>
                  <MDBCol xl="4" md="4" sm="4">
                    <p className="centerCount">{loading?<Skeleton height={20} />:this.state.count.topOfficecountry.isoCode?this.state.count.topOfficecountry.isoCode.fullname  :""}</p>
                  </MDBCol>
                  <MDBCol  md="4" sm="4" style={{paddingRight:0}}>
                   <p className="centerName">{allStrings.country.isoCode}</p>
                  </MDBCol>
                  <MDBCol  md="4" sm="4">
                  <img alt="" style={{width: '70px',height: '70px',borderRadius:'100%',marginBottom:'10px',float: 'right'}} src={require('../../assets/images/profileicon.jpg')}></img>
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="6" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard">{allStrings.topgiftscountry.isoCode}</p>
                <MDBRow>
                  <MDBCol  md="4" sm="4">
                    <p className="centerCount">{loading?<Skeleton height={20} />:this.state.count.topgiftscountry.isoCode?this.props.isRTL?this.state.count.topgiftscountry.isoCode.name_ar:this.state.count.topgiftscountry.isoCode.name_en:''}</p>
                  </MDBCol>
                  <MDBCol  md="4" sm="4" style={{paddingRight:0}}>
                   <p className="centerName">{allStrings.country.isoCode}</p>
                  </MDBCol>
                  <MDBCol  md="4" sm="4">
                  <img alt="" style={{width: '70px',height: '70px',borderRadius:'100%',marginBottom:'10px',float: 'right'}} src={require('../../assets/images/profileicon.jpg')}></img>
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="6" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard">{allStrings.topProductSale}</p>
                <MDBRow>
                  <MDBCol  md="4" sm="4">
                  <p className="centerCount">{loading?<Skeleton height={20} />:this.state.count.topProductSale?this.props.isRTL?this.state.count.topProductSale.name_ar:this.state.count.topProductSale.name_en:''}</p>
                  </MDBCol>
                  <MDBCol  md="4" sm="4" style={{paddingRight:0}}>
                   <p className="centerName">{allStrings.saleCount}</p>
                  </MDBCol>
                  <MDBCol  md="4" sm="4">
                  <img alt="" style={{width: '70px',height: '70px',borderRadius:'100%',marginBottom:'10px',float: 'right'}} src={require('../../assets/images/profileicon.jpg')}></img>
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
        </MDBRow>
        */}
        <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
          <MDBCol xl="8" lg="7" md="12" sm="12">
            <div className="theCard" style={{minHeight:'505px'}}>
              <p className="topCard" style={{color: '#43425D',textAlign: this.props.isRTL?'right':'left'}}>{allStrings.gifts}</p>
              <br></br>
              <table className="table table-borderless homeTable">
                <thead className="thead-light">
                  <tr >
                    <th scope="col">{allStrings.name}</th>
                    <th scope="col">{allStrings.owner}</th>
                    <th scope="col">{allStrings.end}</th>
                    <th scope="col">{allStrings.type}</th>
                  </tr>
                </thead>
                <tbody>
                {this.state.loading?
                
                <div style={{width:"100%"}} >
                  <Skeleton height={40} /> 
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                </div>
                :
                this.state.gifts.length > 0 ?
                  this.state.gifts.map(val=>(
                      <tr onClick={()=>this.props.history.push("/giftInfo",{data:val})}>
                        <td>{val.name}</td>
                        <td>{val.owner?val.owner.fullname:allStrings.notExist}</td>
                        <th>{val.end===true?allStrings.yes:allStrings.no}</th>
                        <th>{val.type==="PRIVATE"?allStrings.private:allStrings.public}</th>
                      </tr>
                  ))
                  :
                  <tr style={{height: '300px'}}>
                      <th colSpan="8" className="noData" style={{background:"#fff"}}>
                      <p style={{marginTop:'10rem',textAlign:'center',}}>{allStrings.noData}</p> 
                      </th>
                  </tr>
                }
                </tbody>
              </table>
              <hr></hr>
              <NavLink to="gifts">
                <span style={{display:'block',marginBottom:'8px'}}>{allStrings.showAll}</span>
              </NavLink>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="5" md="12" sm="12">
            <div className="theCard" style={{minHeight:'505px'}}>
              <NavLink to="users">
                <span style={{position: 'absolute'}}>{allStrings.showAll}</span>
              </NavLink>
              <p className="topCard"  style={{color: '#43425D'}}>{allStrings.lastUsers}</p>
              <img alt="" width="100%" src={require('../../assets/images/Map.png')}></img>
              <div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[0]}) }}>
                <span className="rightSpan">{lastUsers[0]?lastUsers[0].fullname?lastUsers[0].fullname.substr(0,10):allStrings.notExist:"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{color:'#54D8FF'}}></span>
                  <span className="spanNum">{lastUsers[0]?lastUsers[0].country?lastUsers[0].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div>
              <div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[0]}) }}>
                <span className="rightSpan">{lastUsers[1]?lastUsers[1].fullname?lastUsers[1].fullname.substr(0,10):allStrings.notExist:"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#5EE2A0'}}></span>
                  <span className="spanNum">{lastUsers[1]?lastUsers[1].country?lastUsers[1].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div>
              <div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[2]}) }}>
                <span className="rightSpan">{lastUsers[2]?lastUsers[2].fullname?lastUsers[2].fullname.substr(0,10):allStrings.notExist:"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FFA177'}}></span>
                  <span className="spanNum">{lastUsers[2]?lastUsers[2].country?lastUsers[2].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div>
              <div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[3]}) }}>
                <span className="rightSpan">{lastUsers[3]?lastUsers[3].fullname?lastUsers[3].fullname.substr(0,10):allStrings.notExist:"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#A3A1FB'}}></span>
                  <span className="spanNum">{lastUsers[3]?lastUsers[3].country?lastUsers[3].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div>
              <div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[4]}) }}>
                <span className="rightSpan">{lastUsers[4]?lastUsers[4].fullname?lastUsers[4].fullname.substr(0,10):allStrings.notExist:"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FBA69D'}}></span>
                  <span className="spanNum">{lastUsers[4]?lastUsers[4].country?lastUsers[4].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div>
              <div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[5]}) }}>
                <span className="rightSpan">{lastUsers[5]?lastUsers[5].fullname?lastUsers[5].fullname.substr(0,10):allStrings.notExist:"-" }</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FF7CC3'}}></span>
                  <span className="spanNum">{lastUsers[5]?lastUsers[5].country?lastUsers[5].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div>
              <div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[6]}) }}>
                <span className="rightSpan">{lastUsers[6]?lastUsers[6].fullname?lastUsers[6].fullname.substr(0,10):allStrings.notExist:"-" }</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FF7CC3'}}></span>
                  <span className="spanNum">{lastUsers[6]?lastUsers[6].country?lastUsers[6].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div>
              <div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[7]}) }}>
                <span className="rightSpan">{lastUsers[7]?lastUsers[7].fullname?lastUsers[7].fullname.substr(0,10):allStrings.notExist:"-" }</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FF7CC3'}}></span>
                  <span className="spanNum">{lastUsers[7]?lastUsers[7].country?lastUsers[7].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div>
              <div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[8]}) }}>
                <span className="rightSpan">{lastUsers[8]?lastUsers[8].fullname?lastUsers[8].fullname.substr(0,10):allStrings.notExist:"-" }</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FF7CC3'}}></span>
                  <span className="spanNum">{lastUsers[8]?lastUsers[8].country?lastUsers[8].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div><div onClick={()=>{this.props.history.push("userInfo",{data:lastUsers[9]}) }}>
                <span className="rightSpan">{lastUsers[9]?lastUsers[9].fullname?lastUsers[9].fullname.substr(0,10):allStrings.notExist:"-" }</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FF7CC3'}}></span>
                  <span className="spanNum">{lastUsers[9]?lastUsers[9].country?lastUsers[9].country.isoCode:allStrings.notExist:"-"}</span>
                </p>
              </div>

            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer> 
      </Spin>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  setUser,
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(Home)
);
